import { Component } from 'react';
import PropTypes from 'prop-types';

class AdminBarStatusProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasAdminBarOffset: false,
        };
        this.showHandler = () => this.setState({ hasAdminBarOffset: true });
        this.hideHandler = () => this.setState({ hasAdminBarOffset: false });
    }

    componentWillMount() {
        const adminBar = document.querySelector('[data-admin-bar]');
        if (adminBar) {
            adminBar.setAttribute('data-sticky', true);
            this.setState({ hasAdminBarOffset: !adminBar.getAttribute('data-hidden') });
        }
        window.addEventListener('brandContainer.ui.adminBarShown', this.showHandler);
        window.addEventListener('brandContainer.ui.adminBarHidden', this.hideHandler);
    }

    componentWillUnmount() {
        const adminBar = document.querySelector('[data-admin-bar]');
        if (adminBar) {
            adminBar.removeAttribute('data-sticky');
        }
        window.removeEventListener('brandContainer.ui.adminBarShown', this.showHandler);
        window.removeEventListener('brandContainer.ui.adminBarHidden', this.hideHandler);
    }

    render() {
        return this.props.render(this.state.hasAdminBarOffset);
    }
}

AdminBarStatusProvider.propTypes = {
    render: PropTypes.func.isRequired,
};

export default AdminBarStatusProvider;



// WEBPACK FOOTER //
// ./~/@99designs/ddo/components/AdminBarStatusProvider.js